import { useEffect } from "react";

const CONFETTI = ["#0D9488", "#6366F1", "#F59E0B", "#F43F5E", "#10B981", "#3B82F6"];
const BURST = Array.from({ length: 46 }, (_, i) => ({ x: Math.cos((i / 46) * Math.PI * 2) * (120 + (i % 5) * 40), y: Math.sin((i / 46) * Math.PI * 2) * (90 + (i % 4) * 35) - 60, color: CONFETTI[i % CONFETTI.length], delay: (i % 6) * 0.03 }));

export default function MilestoneBurst({ info, onDone, verb = "paid off" }) {
  useEffect(() => {
    const t = setTimeout(onDone, 2600);
    return () => clearTimeout(t);
  }, [info, onDone]);
  return (
    <div className="pointer-events-none fixed inset-0 z-[100] grid place-items-center" data-testid="milestone-burst">
      <style>{`@keyframes hb-burst { 0% { transform: translate(0,0) scale(.4); opacity: 1 } 80% { opacity: 1 } 100% { transform: translate(var(--x), var(--y)) scale(1) rotate(260deg); opacity: 0 } } @keyframes hb-pop { 0% { transform: scale(.6); opacity: 0 } 20% { transform: scale(1.08); opacity: 1 } 85% { transform: scale(1); opacity: 1 } 100% { transform: scale(.95); opacity: 0 } }`}</style>
      <div className="relative">
        {BURST.map((p, i) => <span key={i} className="absolute left-1/2 top-1/2 h-2.5 w-2.5 rounded-sm" style={{ background: p.color, "--x": `${p.x}px`, "--y": `${p.y}px`, animation: `hb-burst 1.4s ${p.delay}s cubic-bezier(.2,.7,.3,1) forwards` }} />)}
        <div className="rounded-full bg-card shadow-2xl border px-6 py-3 flex items-center gap-3" style={{ animation: "hb-pop 2.6s ease forwards" }}>
          <span className="font-display text-3xl font-extrabold text-income" data-testid="milestone-pct">{info.milestone}%</span>
          <span className="text-sm font-medium">{info.milestone === 100 ? `${info.name} complete!` : `of ${info.name} ${verb}`}</span>
        </div>
      </div>
    </div>
  );
}
